export const subitemType = 'object';
export const accept = 'image/*,.pdf';//,.rar,.zip